<script lang="ts">
  interface Props {
    href?: string;
    suffix?: string;
  }
  let { href = '/', suffix = 'Auth' }: Props = $props();
</script>

<a class="brand" {href}>
  <span class="brand-mark" aria-hidden="true">
    <svg viewBox="0 0 32 32" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bm-g" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stop-color="#ccf5ff"/>
          <stop offset="55%" stop-color="#00d4ff"/>
          <stop offset="100%" stop-color="#006699"/>
        </linearGradient>
      </defs>
      <rect class="bm-bg" width="32" height="32" rx="7"/>
      <path class="bm-shield" d="M16 5 L8 8 L8 15 Q8 22 16 25 Q24 22 24 15 L24 8 Z"/>
    </svg>
  </span>
  <span class="brand-name">Vu<em>{suffix}</em></span>
</a>

<style>
  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: var(--text);
  }
  .brand-mark {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    line-height: 0;
  }
  .bm-bg {
    fill: var(--bg-card, #050a14);
  }
  .bm-shield {
    fill: url(#bm-g);
  }
  :global([data-theme='brutalist']) .brand-mark {
    border: 2px solid var(--text);
    box-shadow: 3px 3px 0 var(--text);
  }
  :global([data-theme='brutalist']) .bm-bg {
    fill: var(--bg);
  }
  :global([data-theme='brutalist']) .bm-shield {
    fill: var(--text);
  }
  :global([data-theme='brutalist']) .brand-mark svg {
    width: 28px;
    height: 28px;
  }
  .brand-name {
    font-weight: 700;
    font-size: 16px;
    letter-spacing: -0.02em;
  }
  .brand-name em {
    font-family: var(--font-serif);
    font-style: italic;
    font-weight: 400;
    color: var(--accent);
    margin-left: 2px;
  }
  :global([data-theme='brutalist']) .brand-name em {
    color: var(--text);
  }
</style>
